import moment from 'moment';

import { OrderMethods } from '@/enums';

export const formatPhoneNumber = (phoneNumberString) => {
  const cleaned = ('' + phoneNumberString).replace(/\D/g, '');
  const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    const intlCode = (match[1] ? '' : '');
    return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
  }
  return null;
}

export const getOrderMethod = (deliveryMode) => {
  switch (deliveryMode) {
    case 'pickup':
      return 'Pick-up';
    case 'curbside':
      return 'Curbside';
    case 'delivery':
    case 'dispatch':
      return 'Delivery';
  }
  return '';
}

export const parseDate = (dateInput): Date => {
  if (!dateInput) {
    return new Date();
  }

  const parsedDate = moment(dateInput, 'YYYYMMDD HH:mm');
  if (parsedDate.isValid()) {
    return parsedDate.toDate();
  }

  return new Date();
}

export const dayToIndexMap: Map<string, number> = new Map([
  ['Sunday', 0],
  ['Monday', 1],
  ['Tuesday', 2],
  ['Wednesday', 3],
  ['Thursday', 4],
  ['Friday', 5],
  ['Saturday', 6],
]);

export const indexToDayMap: Map<number, string> = new Map([
  [0, 'Sunday'],
  [1, 'Monday'],
  [2, 'Tuesday'],
  [3, 'Wednesday'],
  [4, 'Thursday'],
  [5, 'Friday'],
  [6, 'Saturday'],
]);

export const addHoursToDate = (date: Date, hours: number): Date => {
  return new Date(new Date(date).setHours(date.getHours() + hours));
}

export const hourMethodMap: Map<string, string> = new Map([
  [OrderMethods.PICKUP, 'pickup'],
  [OrderMethods.CURBSIDE, 'curbsidepickup'],
  [OrderMethods.DELIVERY, 'delivery'],
  [OrderMethods.DISPATCH, 'dispatch'],
]);

export const roundUp = (x, increment) => {
  return Math.ceil(x / increment) * increment;
}

export const formatHour = (hours) => {
  const mins = hours.slice(-2);
  hours = parseInt(hours.slice(0, 2), 10);
  const suffix = hours >= 12 ? 'PM' : 'AM';
  hours = `${((hours + 11) % 12 + 1)}:${mins} ${suffix}`;
  return hours;
}

export const deDuplicateArray = (array: any[]) => {
  return array.filter((v, i, a) => a.findIndex((t) => (t.id === v.id)) === i);
}

export const getStateSelectorItems = () => {
  const states = ['AK', 'AL', 'AR', 'AS', 'AZ', 'CA', 'CO', 'CT', 'DC', 'DE', 'FL', 'GA', 'GU', 'HI', 'IA', 'ID', 'IL', 'IN', 'KS', 'KY', 'LA', 'MA', 'MD', 'ME', 'MI', 'MN', 'MO', 'MP', 'MS', 'MT', 'NC', 'ND', 'NE', 'NH', 'NJ', 'NM', 'NV', 'NY', 'OH', 'OK', 'OR', 'PA', 'PR', 'RI', 'SC', 'SD', 'TN', 'TX', 'UM', 'UT', 'VA', 'VI', 'VT', 'WA', 'WI', 'WV', 'WY'];
  const results: SelectorItem[] = [];

  results.push({
    value: '',
    id: '',
    label: ''
  });

  states.forEach((state) => {
    results.push({
      value: state,
      id: state,
      label: state
    });
  });

  return results;
}

export const getGenderSelectorItems = () => {
  const genders = ['Female', 'Male', 'Other'];
  const results: SelectorItem[] = [];

  results.push({
    value: '',
    id: '',
    label: ''
  });

  genders.forEach((gender) => {
    results.push({
      value: gender,
      id: gender,
      label: gender
    });
  });

  return results;
}

export const hideCMSContent = () => {
  const cmsContent = document.getElementById('cms-content');
  if (cmsContent) {
    if (!cmsContent.classList.contains('hidden')) {
      cmsContent.classList.add('hidden');
    }
  }

  const cmsHeader = document.getElementById('cms-header');
  if (cmsHeader) {
    if (!cmsHeader.classList.contains('hidden')) {
      cmsHeader.classList.add('hidden');
    }
  }

  const cmsFooter = document.getElementById('cms-footer');
  if (cmsFooter) {
    if (!cmsFooter.classList.contains('hidden')) {
      cmsFooter.classList.add('hidden');
    }
  }
}
